import React, { useState } from 'react';
import { Card, CardBody } from 'reactstrap';

export const SectionCard = ({ title, children, className }) => (
    <Card className={className}>
        <CardBody>
            <h5 className="mb-3">{title}</h5>
            {children}
        </CardBody>
    </Card>
);

export const KeyValueGrid = ({ items }) => (
    <table className="table table-sm">
        <tbody>
            {items.map(([label, value]) => (
                <tr key={label}>
                    <th style={{ width: 220 }}>{label}</th>
                    <td>{value === null || typeof value === 'undefined' || value === '' ? '—' : value}</td>
                </tr>
            ))}
        </tbody>
    </table>
);

export const JsonBlock = ({ label, value }) => {
    const [open, setOpen] = useState(false);

    if (value === null || typeof value === 'undefined') {
        return (
            <div className="mb-2">
                <strong>{label}:</strong> <span className="text-muted">—</span>
            </div>
        );
    }

    return (
        <div className="mb-2">
            <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                onClick={() => setOpen(prev => !prev)}
            >
                {open ? 'Hide' : 'Show'} {label}
            </button>
            {open && (
                <pre className="mt-2 p-2" style={{ background: '#f5f5f5', maxHeight: 300, overflow: 'auto' }}>
                    {JSON.stringify(value, null, 2)}
                </pre>
            )}
        </div>
    );
};
